import { render } from "./GedView.vue?vue&type=template&id=b324d086"
import script from "./GedView.vue?vue&type=script&lang=js"
export * from "./GedView.vue?vue&type=script&lang=js"

import exportComponent from "/root/dirif/preprod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__